// owner/shell/ForgetOnSignOut.js — when nobody is signed in, forget every owner figure loaded so far.
// The screens' data (units, bookings, money, guest requests) lives in React Query's in-memory cache, and signing out
// does not reload the page. Without this, the next person to sign in on the same device — another owner, or the
// store-review demo account after a real one — would briefly see the previous owner's data until fresh reads land.
// It watches the signed-out STATE, not the button, so every way out is covered: «تسجيل الخروج», a refused renewal,
// another tab signing out. Mounted once inside AuthProvider + QueryClientProvider (the store app's OwnerApp; the web
// mounts it with the owner pages at the web switch). Found in the 8c batch 2 walkthrough; fix approved by Adil, 4 Nov.

import { useContext, useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { AuthContext } from '../../context/AuthContext';

const ForgetOnSignOut = () => {
  const { isAuthenticated, loading } = useContext(AuthContext);
  const queryClient = useQueryClient();
  useEffect(() => {
    if (!loading && !isAuthenticated) queryClient.clear();
  }, [isAuthenticated, loading, queryClient]);
  return null;
};

export default ForgetOnSignOut;
